export interface Fee {
  id: number;
  name: string;
  isActive: boolean;
  billingPeriod: Date;
  unitMeasure: string;
  feeTypeId: number;
  locationId: number;
  carrierId: number;
  eventTypeTriggerId: number;
}

export interface FeeType {
  id: number;
  name: string;
  isActive: boolean;
}
